module.exports = __webpack_public_path__ + "img/icon-add-support.a379dd24.svg";